import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { Router } from '@angular/router';
import { ApiEndpoint } from '@shared/shared/enums/api-endpoints.enum';
import { IRestaurant } from '@shared/shared/interfaces/restaurant.interface';
import { LanguageService } from '@shared/shared/services/language-service';
import { replaceTemplateKeys } from '@shared/utils/url.lib';
import * as RestaurantActions from '../actions/restaurant.actions';

const headers = new HttpHeaders({
  'Cache-Control': 'no-cache, no-store',
});
@Injectable()
export class RestaurantEffects {
  constructor(
    private actions$: Actions,
    private http: HttpClient,
    private languageService: LanguageService,
    private router: Router
  ) {}

  public viewRestaurant$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RestaurantActions.VIEW_RESTAURANT),
      switchMap((action: RestaurantActions.ViewRestaurant) => {
        const url = replaceTemplateKeys(ApiEndpoint.RESTAURANTS, {
          id: action.id.toString(),
          locale: this.languageService.currentLanguage,
        });

        return this.http.get<IRestaurant>(url, { headers }).pipe(
          map((restaurant) => new RestaurantActions.ViewRestaurantSuccess(restaurant)),
          catchError((error) => {
            this.router.navigate(['/error/not-found']);
            return of(new RestaurantActions.ViewRestaurantFail(error));
          })
        );
      })
    )
  );
}
